
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';
import ProductCard from '../../components/base/ProductCard';
import { updateSEO, seoData, getBaseURL } from '../../utils/seo';

export default function BagsPage() {
  useEffect(() => {
    updateSEO({
      ...seoData.bags,
      canonical: `${getBaseURL()}/bags`,
      ogTitle: seoData.bags.title,
      ogDescription: seoData.bags.description,
      ogImage: `${getBaseURL()}/og-image.jpg`
    });
  }, []);

  const [selectedFilter, setSelectedFilter] = useState('Todos');
  const [sortBy, setSortBy] = useState('Relevância');

  const filters = ['Todos', 'Bolsas', 'Mochilas', 'Carteiras', 'Necessaires', 'Malas'];
  const sortOptions = ['Relevância', 'Menor Preço', 'Maior Preço', 'Mais Novos'];

  const products = [
    {
      id: '1',
      image: 'https://public.readdy.ai/ai/img_res/3d8bb409e9a10fff1966390ad7f1fac0.jpg',
      brand: 'DLUXMEN',
      name: 'Bolsa Premium Couro',
      price: 'R$ 459,90',
      originalPrice: 'R$ 599,90',
      isNew: true
    },
    {
      id: '2',
      image: 'https://readdy.ai/api/search-image?query=luxury%20backpack%20premium%20materials%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20backpack%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-backpack-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Mochila Executiva Premium',
      price: 'R$ 389,90',
      isNew: true
    },
    {
      id: '3',
      image: 'https://readdy.ai/api/search-image?query=luxury%20wallet%20premium%20leather%20with%20sophisticated%20craftsmanship%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20wallet%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20materials&width=400&height=500&seq=dluxmen-wallet-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Carteira Couro Italiano',
      price: 'R$ 189,90',
      originalPrice: 'R$ 249,90'
    },
    {
      id: '4',
      image: 'https://readdy.ai/api/search-image?query=luxury%20travel%20bag%20premium%20materials%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20travel%20bag%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-travel-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Mala de Viagem Luxury',
      price: 'R$ 699,90'
    },
    {
      id: '5',
      image: 'https://readdy.ai/api/search-image?query=luxury%20clutch%20bag%20premium%20leather%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20clutch%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20craftsmanship&width=400&height=500&seq=dluxmen-clutch-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Clutch Elegante Premium',
      price: 'R$ 229,90',
      isNew: true
    },
    {
      id: '6',
      image: 'https://readdy.ai/api/search-image?query=luxury%20briefcase%20premium%20leather%20with%20sophisticated%20business%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20briefcase%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-briefcase-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Pasta Executiva Premium',
      price: 'R$ 549,90',
      originalPrice: 'R$ 699,90'
    },
    {
      id: '7',
      image: 'https://readdy.ai/api/search-image?query=luxury%20cosmetic%20bag%20premium%20materials%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20necessaire%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality&width=400&height=500&seq=dluxmen-cosmetic-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Necessaire Premium',
      price: 'R$ 149,90'
    },
    {
      id: '8',
      image: 'https://readdy.ai/api/search-image?query=luxury%20shoulder%20bag%20premium%20leather%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20shoulder%20bag%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality%20craftsmanship&width=400&height=500&seq=dluxmen-shoulder-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Bolsa Tiracolo Luxury',
      price: 'R$ 329,90',
      originalPrice: 'R$ 429,90'
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8', fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Page Header */}
      <section className="pt-24 pb-8" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <h1 
            className="text-5xl font-bold mb-4 max-md:text-3xl"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#0B0B0B'
            }}
          >
            Bags
          </h1>
          <p 
            className="text-lg max-md:text-base"
            style={{ 
              color: '#C0C0C0',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            Coleção premium de bolsas e acessórios em couro italiano
          </p>
        </div>
      </section>

      {/* Filters and Sort */}
      <section className="py-6 border-b" style={{ backgroundColor: '#F8F8F8', borderColor: '#C0C0C0' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0">
            {/* Filters */}
            <div className="flex items-center space-x-6 overflow-x-auto pb-2 max-md:space-x-4">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap pb-2 border-b-2 transition-all duration-200 ${
                    selectedFilter === filter 
                      ? 'border-green-800 text-green-800' 
                      : 'border-transparent text-gray-600 hover:text-green-800'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {filter}
                </button>
              ))}
            </div>

            {/* Sort */}
            <div className="flex items-center space-x-2">
              <span 
                className="text-sm font-medium"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Ordenar por:
              </span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="text-sm font-medium border-none bg-transparent focus:outline-none pr-8"
                style={{ 
                  color: '#0B0B0B',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                {sortOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-md:gap-4">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
                onClick={() => {
                  console.log('Produto clicado:', product.name);
                }}
              />
            ))}
          </div>

          {/* Load More */}
          <div className="text-center mt-12">
            <button
              className="px-8 py-3 font-semibold text-white rounded-lg transition-all duration-300 hover:bg-green-700"
              style={{ 
                backgroundColor: '#0F3F2F',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Carregar Mais Produtos
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
